export default {
  EQUITY_STORY: 0,
  COMMERCIAL_REGISTER: 1,
  SUMMARY: 2,
  SUMMARY_ACCUMULATED: 3,
  SUMMARY_INVESTORS: 4,
};
